export const INPUT_ELEMENT_NAME = 'INPUT'
